import { homApi } from '~/redux/apis/hom'
import { userStats } from '~/games/types/treasureTrail.types'

export const treasureTrailApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    setGameStats: builder.mutation<{ type: 'success' | 'error' }, userStats>({
      query: (data) => ({
        url: '/v1/games/math-path/activity',
        method: 'POST',
        body: data,
      }),
    }),
    GetSummary: builder.query<unknown, void>({
      query: () => ({
        url: '/v1/games/math-path/summary',
        method: 'GET',
      }),
    }),
  }),
})
export const { useSetGameStatsMutation ,useLazyGetSummaryQuery } = treasureTrailApi
